<div class="default-container">
    <div class="wrapper">
        <div class="container-breadcrumbs">
            <a [href]="callbackUrl" *ngIf="callbackUrl">
                <mat-icon>keyboard_arrow_left</mat-icon>
                {{ 'NEXT_STEPS.EXTERNAL_APP.CALLBACK_URL' | translate }}
            </a>
            <ng-container *ngIf="!callbackUrl">
                <app-breadcrumbs
                    formerPage="{{
                        (planning ? 'COMMON.BREADCRUMBS.PLANNING_PROJECT' : 'COMMON.BREADCRUMBS.OVERVIEW') | translate
                    }}"
                    currentPage="{{ 'COMMON.BREADCRUMBS.NEXT_STEPS' | translate }}"
                    [navigateTo]="planning ? ['../', 'planning-project', salesforceId] : '/overview'"
                ></app-breadcrumbs>
            </ng-container>
        </div>
        <div class="container-content">
            <div class="content-content">
                <div class="content-header">
                    <h2><mat-icon>check_circle</mat-icon> {{ 'NEXT_STEPS.HEADER.CREATED' | translate }}</h2>
                    <div class="header-number">
                        {{ 'NEXT_STEPS.HEADER.NUMBER' | translate : { number: sapDocumentId } }}
                    </div>
                </div>
                <div class="content-item">
                    <app-documents-selection
                        [sapDocumentId]="sapDocumentId"
                        [documentId]="documentId"
                        [latestRevision]="latestRevision"
                        [printType]="printType"
                    ></app-documents-selection>
                </div>
                <div class="content-toolbar">
                    <div class="toolbar-button-back">
                        <a mat-button color="primary" [href]="callbackUrl" *ngIf="callbackUrl">
                            <mat-icon>arrow_back</mat-icon>
                            {{ 'NEXT_STEPS.EXTERNAL_APP.CALLBACK_URL' | translate }}
                        </a>
                        <a
                            mat-button
                            color="primary"
                            [routerLink]="['../', 'planning-project', salesforceId]"
                            *ngIf="planning"
                        >
                            <mat-icon>arrow_back</mat-icon>
                            {{ 'NEXT_STEPS.PLANNING.BACK_TO_PROJECT_OVERVIEW' | translate }}
                        </a>
                        <button
                            mat-button
                            color="primary"
                            [routerLink]="['/overview']"
                            *ngIf="!planning && !callbackUrl"
                        >
                            <mat-icon>arrow_back</mat-icon>
                            {{ 'NEXT_STEPS.BUTTON.BACK_TO_OVERVIEW' | translate }}
                        </button>
                    </div>
                    <div class="toolbar-button-group">
                        <ng-container *ngIf="appService.getLocation() === 'DE'">
                            <div class="button-group-menu d-lg-none" *ngIf="appService.getLocation() === 'DE'">
                                <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu" yPosition="above" xPosition="before" class="default-menu">
                                    <ul>
                                        <li>
                                            <a target="_blank" [href]="foerderProfiUrl">
                                                {{ 'NEXT_STEPS.BUTTON.OPEN_FOERDER_PROFI' | translate }}
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" [href]="serviceConfiguratorUrl">
                                                {{ 'NEXT_STEPS.BUTTON.SERVICE_CONFIGURATOR' | translate }}
                                            </a>
                                        </li>
                                    </ul>
                                </mat-menu>
                            </div>
                            <div class="default-button-group d-none d-lg-flex">
                                <a mat-stroked-button color="primary" target="_blank" [href]="foerderProfiUrl">
                                    {{ 'NEXT_STEPS.BUTTON.OPEN_FOERDER_PROFI' | translate }}
                                </a>
                                <a mat-stroked-button color="primary" target="_blank" [href]="serviceConfiguratorUrl">
                                    {{ 'NEXT_STEPS.BUTTON.SERVICE_CONFIGURATOR' | translate }}
                                </a>
                            </div>
                        </ng-container>
                        <a mat-flat-button color="primary" target="_blank" [href]="shopUrl">
                            {{ 'NEXT_STEPS.BUTTON.ORDER_ONLINE_IN_PARTNER_SHOP' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
